// Cookie (BFF) session: the API and the notification hub are same-origin
// relative paths behind the app's own proxy (vite in dev, nginx in prod) -
// no OIDC settings on the client at all.
export default {
  VITE_API_URL: import.meta.env.VITE_API_URL,
  VITE_WS_API_URL: import.meta.env.VITE_WS_API_URL,
  VITE_MUI_LICENSE: import.meta.env.VITE_MUI_LICENSE,
  VITE_RESOURCE_INSTRUCTION: import.meta.env.VITE_RESOURCE_INSTRUCTION,
  VITE_RESOURCE_SUPPORT: import.meta.env.VITE_RESOURCE_SUPPORT,
  VITE_FEATURE_LIGHT_DARK_MODE: import.meta.env.VITE_FEATURE_LIGHT_DARK_MODE,
  VITE_FEATURE_FLAG_SWITCHER: import.meta.env.VITE_FEATURE_FLAG_SWITCHER,
  VITE_SUPPLY_SYSTEM_URL: import.meta.env.VITE_SUPPLY_SYSTEM_URL,
  VITE_CRM_URL: import.meta.env.VITE_CRM_URL,
  VITE_ADMIN_URL: import.meta.env.VITE_ADMIN_URL,
  VITE_FEATURE_FLAG_PSO_PRICES_FORMULA_SETTINGS:
    import.meta.env.VITE_FEATURE_FLAG_PSO_PRICES_FORMULA_SETTINGS === 'true',
};
